import React, { useState } from 'react';
import { Select, MenuItem, Box, TextField, Button, InputLabel, FormControl } from '@mui/material';
import { API_BASE_URL } from '../Config/apiConfig';

const MonitoringPage = () => {
  const [siteCode, setSiteCode] = useState('');
  const [serverID, setServerID] = useState('');

  // Just use the base URL directly from the config
  // The API_BASE_URL should be something like 'https://localhost:44350' or 'http://localhost:8080'
  const baseUrl = API_BASE_URL;

  const [selectedUrl, setSelectedUrl] = useState(
    `${baseUrl}/d/RrS7v977k/all-markets-gameplay-overview?` +
    'orgId=1&from=now-3h&to=now&timezone=utc&var-site=NJP&var-site=PAP&var-site=MIP&var-site=CTP&var-site=ONP&refresh=1m'
  );

  const [monitoringUrls, setMonitoringUrls] = useState([
    {
      label: 'All Markets Gameplay Overview',
      url: `${baseUrl}/d/RrS7v977k/all-markets-gameplay-overview?` +
        'orgId=1&from=now-3h&to=now&timezone=utc&var-site=NJP&var-site=PAP&var-site=MIP&var-site=CTP&var-site=ONP&refresh=1m'
    },
    {
      label: 'Casino ID Level Monitoring',
      url: `${baseUrl}/d/oOf7W4pGz/casino-id-level-monitoring?` +
        `orgId=1&from=now-6h&to=now&var-Site=${siteCode}&var-ServerID=${serverID}&refresh=1m`
    },
    {
      label: 'Dashboards',
      url: `${baseUrl}/dashboards`
    },
  ]);

  const siteCodeOptions = ['NJS', 'NJP', 'PAP', 'MIP', 'CTP', 'ONP'];

  const handleUrlChange = (event) => {
    setSelectedUrl(event.target.value);
  };

  const handleGoClick = () => {
    // Update "Casino ID Level Monitoring" to use the user's siteCode/serverID
    const updatedUrls = monitoringUrls.map((item) => {
      if (item.label === 'Casino ID Level Monitoring') {
        return {
          ...item,
          url:
            `${baseUrl}/d/oOf7W4pGz/casino-id-level-monitoring?` +
            `orgId=1&from=now-6h&to=now&var-Site=${siteCode}&var-ServerID=${serverID}&refresh=1m`,
        };
      }
      return item;
    });

    setMonitoringUrls(updatedUrls);

    // Auto-select the updated "Casino ID Level Monitoring" URL
    setSelectedUrl(
      `${baseUrl}/d/oOf7W4pGz/casino-id-level-monitoring?` +
      `orgId=1&from=now-6h&to=now&var-Site=${siteCode}&var-ServerID=${serverID}&refresh=1m`
    );
  };

  return (
    <Box sx={{ padding: '20px' }}>
      {/* Dropdown for dashboards */}
      <FormControl variant="outlined" sx={{ marginBottom: '20px', width: '300px' }}>
        <InputLabel>Monitoring Dashboard</InputLabel>
        <Select value={selectedUrl} onChange={handleUrlChange} label="Monitoring Dashboard">
          {monitoringUrls.map((option, idx) => (
            <MenuItem key={idx} value={option.url}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {/* Site Code / Server ID inputs */}
      <Box sx={{ display: 'flex', gap: '10px', marginBottom: '20px' }}>
        <FormControl variant="outlined" sx={{ width: '200px' }}>
          <InputLabel>Site Code</InputLabel>
          <Select
            value={siteCode}
            onChange={(e) => setSiteCode(e.target.value)}
            label="Site Code"
          >
            {siteCodeOptions.map((code) => (
              <MenuItem key={code} value={code}>
                {code}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <TextField
          label="Server ID"
          variant="outlined"
          value={serverID}
          onChange={(e) => {
            if (e.target.value.length <= 5) {
              setServerID(e.target.value);
            }
          }}
          inputProps={{ maxLength: 5 }}
        />

        <Button variant="contained" onClick={handleGoClick}>
          Go
        </Button>
      </Box>

      {/* Iframe */}
      <iframe
        src={selectedUrl}
        title="Monitoring"
        style={{
          width: '100%',
          height: '80vh',
          border: 'none',
        }}
      ></iframe>
    </Box>
  );
};

export default MonitoringPage;